export default {
  methods: {
    async replaceRoute(name, params = {}) {
      try {
        if (this.$route.name !== name) {
          return this.$router
            .replace({ name, params })
            .catch(console.log('route'));
        }
      } catch (e) {
        console.log('error replace', e);
      }
      return this.$route.name;
    },
    async pushRoute(name, params = {}) {
      return this.$route.push({ name, params }).catch();
    },
  },
};
